export default __webpack_public_path__ + "static/sec-title-bg-066b7045469a1d353a3231f6eddf9d08.gif";